var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3972 2.06017C8.91719 1.71302 7.37693 1.71302 5.89694 2.06017C3.9932 2.50674 2.50674 3.9932 2.06017 5.89694C1.71302 7.37693 1.71302 8.91719 2.06017 10.3972C2.50674 12.301 3.9932 13.7875 5.89694 14.2339C7.37693 14.5812 8.91719 14.5812 10.3972 14.2339C12.301 13.7875 13.7875 12.301 14.2339 10.3972C14.5812 8.91719 14.5812 7.37693 14.2339 5.89694C13.7875 3.9932 12.301 2.50674 10.3972 2.06017ZM5.48607 0.307935C7.23646 -0.102645 9.05815 -0.102645 10.8085 0.307935C13.3778 0.910621 15.384 2.91676 15.9866 5.48607C16.3972 7.23646 16.3972 9.05815 15.9866 10.8085C15.7566 11.789 15.3222 12.6875 14.7301 13.4574L17.7364 16.4636C18.0879 16.8151 18.0879 17.385 17.7364 17.7364C17.385 18.0879 16.8151 18.0879 16.4636 17.7364L13.4574 14.7301C12.6875 15.3222 11.789 15.7566 10.8085 15.9866C9.05815 16.3972 7.23646 16.3972 5.48607 15.9866C2.91676 15.384 0.910621 13.3778 0.307935 10.8085C-0.102645 9.05815 -0.102645 7.23646 0.307935 5.48607C0.910621 2.91676 2.91676 0.910621 5.48607 0.307935Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.95b5c35200e18a0e7734a6fa879682c1.svg";
export { ForwardRef as ReactComponent };